import { publishEvent } from "./publishEvent.ts";

export const useEventPublish = () => publishEvent;
